/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Backdrop from 'components/base/Backdrop';
import Badge from 'components/base/Badge';
import Button from 'components/base/Button';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import Icon from 'components/icon';
import { Modal } from 'react-bootstrap';
import CustomModal from './CustomModal';
import styled from '@emotion/styled';
import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import PageLoader from '../animate-component/PageLoader';
const StyledModal = styled(Modal)`
  background-color: #0000004b;
  backdrop-filter: blur(2px);
  & .modal-dialog {
    margin-right: auto;
    /* max-width: fit-content; */
    margin-left: auto;
  }
  & .modal-header .btn-close {
    background-color: #ffffff39;
  }
  & .btn-reveal {
    width: 30px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px !important;
  }
  & .icon-btn {
    padding: 10px;
    width: 30px !important;
    height: 30px !important;
    /* padding: 8px 11px !important; */
  }
`;

const RenderAction = ({
  action,
  defaultLabel,
  defaultIcon,
  className,
  eventKey,
  handleClose
}) => {
  if (action) {
    const handleAction = () => {
      handleClose();
      action.action();
    };
    return (
      <Dropdown.Item
        className={classNames(className, action.className)}
        eventKey={eventKey}
        onClick={handleAction}
      >
        <Icon
          icon={action.icon ?? defaultIcon}
          className={action.iconClassName}
          fontSize={action.fontSize ?? '14px'}
        />{' '}
        {action.label ?? defaultLabel}
      </Dropdown.Item>
    );
  }
  return null;
};

const Action = ({ actions, changeFlag, data, handleClose }) => {
  const getAction = actions(data);
  const { actionStatus, actionDelete } = getAction;
  return (
    <RevealDropdownTrigger>
      <RevealDropdown
        className="position-relative"
        iconClassName="fs-9"
        variant="phoenix-primary"
        btnClassName={' h-100'}
      >
        <RenderAction
          handleClose={handleClose}
          action={actionStatus}
          defaultLabel={'status'}
          defaultIcon={'mdi:block'}
          eventKey={'3'}
        />
        <RenderAction
          handleClose={handleClose}
          action={actionDelete}
          defaultLabel={'Delete'}
          defaultIcon={'heroicons-outline:trash'}
          eventKey={'4'}
          className="text-danger"
        />
        <Backdrop
          show={changeFlag === '1'}
          className={
            'position-absolute flex justify-content-center rounded align-items-center'
          }
        >
          <p className="mb-0 text-warning-300 dark__text-warning-300 fs-9">
            Waiting for approval
          </p>
        </Backdrop>
      </RevealDropdown>
    </RevealDropdownTrigger>
  );
};

const EditViewModal = ({
  show,
  handleClose,
  loading,
  loadingText,
  children,
  status,
  name,
  changeFlag,
  data,
  size = '',
  handleSubmit,
  openEditMode = false,
  actions,
  title,
  isDisable
}) => {
  const [editMode, setEditMode] = useState(openEditMode);
  const firstInputRef = useRef(null);

  useEffect(() => {
    if (editMode && firstInputRef.current) {
      firstInputRef.current.focus();
    }
  }, [editMode]);

  const toggleEditMode = () => {
    setEditMode(!editMode);
  };

  return (
    <>
      <StyledModal
        size={size}
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <div className="card w-100">
          <div className="card-header p-2 px-3">
            <div className="d-flex justify-content-between">
              <OverlayTrigger
                placement={'bottom'}
                overlay={
                  <Tooltip>
                    {name} is {status === 'Active' ? 'active' : 'disable'}.
                  </Tooltip>
                }
              >
                <span>
                  <Badge
                    bg={status === 'Active' ? 'success' : 'danger'}
                    variant="phoenix"
                    iconPosition="end"
                    className="fs-11"
                  >
                    {status === 'Active' ? 'Active' : 'Disable'}
                  </Badge>
                </span>
              </OverlayTrigger>
            </div>
            <div className="d-flex justify-content-between">
              <div className="mt-1">
                <h4 className=" text-1100 mb-0 text-capitalize">{name}</h4>
              </div>

              <div className="d-flex align-items-center gap-2">
                {!isDisable && (
                  <OverlayTrigger
                    placement={'bottom'}
                    overlay={<Tooltip>Edit {title}</Tooltip>}
                  >
                    <div>
                      <Button
                        disabled={changeFlag === '1'}
                        onClick={toggleEditMode}
                        variant={editMode ? 'primary' : 'phoenix-primary'}
                        className="p-1 icon-btn"
                      >
                        <Icon icon="tabler:user-edit" fontSize="16px" />
                      </Button>
                    </div>
                  </OverlayTrigger>
                )}

                {actions && (
                  <Action
                    handleClose={handleClose}
                    data={data}
                    actions={actions}
                    changeFlag={changeFlag}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="card-body py-2 pb-3">
            <div className="">{children(firstInputRef, editMode)}</div>
            <div className="d-flex mt-2 gap-2 justify-content-end">
              <Button
                variant="phoenix-secondary"
                disabled={loading}
                onClick={handleClose}
              >
                Close
              </Button>
              {editMode ? (
                <Button
                  variant="phoenix-success"
                  disabled={loading}
                  onClick={handleSubmit}
                >
                  Save
                </Button>
              ) : null}
            </div>
          </div>
        </div>
        <PageLoader loading={loading} loadingMessage={loadingText} />
      </StyledModal>
    </>
  );
};

export default EditViewModal;
